import { faPlus } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
  setContinueButtonText,
  setContinueDisabled,
  setCurrentSlide,
  setExactReportType,
} from 'store/CustomReports/actions'
import '../styles/customReportStyles.css'
import CourseGroupReportType from './CourseGroupReportType'
import CourseReportType from './CourseReportType'
import { FinalSlide } from './FinalSlide'
import Footer from './Footer'
import ReportType from './GeneralReportType'
import LocationFiltering from './LocationFiltering'
import MyReports from './MyReports'
import RoleFiltering from './RoleFiltering'
import SelectSingleOrMultipleCourseGroups from './SelectSingleOrMultipleCourseGroups'
import SelectSingleOrMultipleCourses from './SelectSingleOrMultipleCourses'
import UnderConstruction from './UnderConstruction'
import { ToastContainer } from 'react-toastify'

function CustomReports() {
  const dispatch = useDispatch()
  const {
    currentSlide,
    selectedReportType,
    selectedCourseReportType,
    downloadingFromMainPage,
    selectedCourseGroupReportType,
    courseLocations,
    courseLocationGroups,
    courseGroupLocations,
    courseGroupLocationGroups,
    courseRoles,
    courseRoleGroups,
    courseGroupRoles,
    courseGroupRoleGroups,
    admins,
    exactReportType,
  } = useSelector((store) => store.customReports)

  useEffect(() => {
    dispatch(setContinueDisabled(true))
    dispatch(setContinueButtonText('Continue'))
  }, [dispatch, currentSlide])

  useEffect(() => {
    dispatch(setExactReportType())
  }, [
    dispatch,
    selectedReportType,
    selectedCourseReportType,
    selectedCourseGroupReportType,
  ])

  console.log(
    selectedReportType,
    selectedCourseReportType,
    selectedCourseGroupReportType,
    'leart50'
  )

  return (
    <div
      className='scrollbar main-content-container pb-3'
      // style={{ maxHeight: '58vh', height: '58vh', overflowY: 'auto' }}
    >
      {!currentSlide ? (
        <>
          <button
            onClick={() => dispatch(setCurrentSlide(1))}
            className='btn btn-info '
            disabled={downloadingFromMainPage}
          >
            New Report <FontAwesomeIcon icon={faPlus} className='ml-1' />
          </button>
          <MyReports />
        </>
      ) : null}

      {currentSlide === 1 && <ReportType />}

      {/* Course Slides */}
      {selectedReportType === 0 && (
        <>
          {currentSlide === 2 && <CourseReportType />}
          {selectedCourseReportType === 0 ? (
            // Single Course Slides
            <>
              {currentSlide === 3 && <SelectSingleOrMultipleCourses />}
              {currentSlide === 4 && (
                <LocationFiltering
                  locations={courseLocations}
                  locationGroups={courseLocationGroups}
                />
              )}
              {currentSlide === 5 && (
                <RoleFiltering
                  roles={courseRoles}
                  roleGroups={courseRoleGroups}
                />
              )}
              {currentSlide === 6 && <FinalSlide />}
            </>
          ) : (
            // Multiple Courses Slides
            <>
              {currentSlide === 3 && (
                <SelectSingleOrMultipleCourses
                  title='Select multiple courses'
                  multiple={true}
                />
              )}
              {currentSlide === 4 && <FinalSlide />}
            </>
          )}
        </>
      )}

      {/* Course Group Slides */}
      {selectedReportType === 1 && (
        <>
          {currentSlide === 2 && <CourseGroupReportType />}
          {selectedCourseGroupReportType === 0 ? (
            // Single Course Group Slides
            <>
              {currentSlide === 3 && <SelectSingleOrMultipleCourseGroups />}{' '}
              {currentSlide === 4 && (
                <LocationFiltering
                  locations={courseGroupLocations}
                  locationGroups={courseGroupLocationGroups}
                />
              )}
              {currentSlide === 5 && (
                <RoleFiltering
                  roles={courseGroupRoles}
                  roleGroups={courseGroupRoleGroups}
                />
              )}
              {currentSlide === 6 && <FinalSlide />}
            </>
          ) : (
            // Multiple Course Group Slides

            <>
              {/* {currentSlide === 3 && (
                <SelectSingleOrMultipleCourseGroups
                  title='Select multiple course groups'
                  multiple={true}
                />
              )} */}
              {currentSlide >= 3 && <UnderConstruction />}
            </>
          )}
        </>
      )}

      {currentSlide ? <Footer /> : null}
      <ToastContainer />
    </div>
  )
}

export default CustomReports
